// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.disabled[data-v-6e9408fd] {\n    cursor: wait;\n}\n.view-account[data-v-6e9408fd] {\n    --highlight-color-focused: white;\n    --inner-border-width: 0;\n    font-weight: bold;\n    color: var(--ion-color-dark-shade);\n    padding-left: 4%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
